import axios from 'app/axiosInstance'

export const getLastSyncDate = () => {
    return axios().get('v1/syncprocess/_latest')
}

export const sync = () => {
    return axios().put('v1/users/_sync')
}

export const syncPatients = () => {
    return axios().put('v1/datasync/_patient')
}

export const syncFiles = () => {
    return axios().put('v1/share/_activate')
}
